// src/api/hooks/useSources.ts
import { useEffect, useState } from 'react';
import { SourceRead } from '../apiTypes';
import { listSources } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';

export function useSources(reportId?: string, driverId?: string, elementId?: string) {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [sources, setSources] = useState<SourceRead[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!reportId || !driverId || !elementId) return;

    const loadSources = async () => {
      setLoading(true);
      try {
        const data = await listSources(reportId, driverId, elementId);
        setSources(data);
        setError(null);
      } catch (err) {
        console.error(err);
        setError('Errore nel caricamento delle sorgenti');
      } finally {
        setLoading(false);
      }
    };

    loadSources();
  }, [reportId, driverId, elementId]);

  return { sources, loading, error };
}
